import * as Types from '../types/Configuration';
import {PAGINATION} from '../../constants/define';
// import HotelRequest from "../mapping/Request/HotelRequest";

const initialState = {
    isFetching: false,
    all: [],
    errors: [],
    masterData: {},
    // item: new HotelRequest().update(),
    item: {},
    configurationCma: {},
    data: {
        result: [],
        page_size: PAGINATION.page_size,
        page_index: PAGINATION.page_index,
        total: PAGINATION.total,
        total_page: PAGINATION.total_page,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.CONFIGURATION_CMA_ACTION:
        case Types.CONFIGURATION_UPDATE_CMA_ACTION:
        case Types.CONFIGURATION_UPDATE_ACTION:
        case Types.CONFIGURATION_MASTER_DATA_ACTION:
        case Types.CONFIGURATION_GET_TEM_ACTION:
            return {...state, isFetching: true};
        case Types.CONFIGURATION_CMA_SUCCESS:
            return {...state, isFetching: false, configurationCma: action?.configurationCma};
        case Types.CONFIGURATION_UPDATE_CMA_SUCCESS:
            return {...state, isFetching: false};
        case Types.CONFIGURATION_UPDATE_SUCCESS:
            return {...state, isFetching: false};
        case Types.CONFIGURATION_MASTER_DATA_SUCCESS:
            return {...state, isFetching: false, masterData: action.masterData};
        case Types.CONFIGURATION_GET_TEM_SUCCESS:
            return {...state, isFetching: false, item: action.item};
        case Types.CONFIGURATION_FAILED:
            return {...state, isFetching: false, errors: action.errors};
        case Types.CONFIGURATION_INIT:
            return initialState;
        default:
            return state;
    }
}
